<template>
  <v-navigation-drawer
    bottom
    color="transparent"
    fixed
    height="auto"
    overlay-color="secondary"
    overlay-opacity=".8"
    temporary
    v-bind="$attrs"
    v-on="$listeners"
  >
    <v-list
      color="white"
      shaped
    >
      <v-list-item
          v-for="(name, index) in items"
          :key="index"
          color="primary"
          @click="$vuetify.goTo(name.link, options)"
      >
        <v-list-item-content>
          <v-list-item-title v-text="name.title" />
        </v-list-item-content>
      </v-list-item>
      <v-list-group
          :value="false"
      >
        <template v-slot:activator>
          <v-list-item-title>Отдых и туризм</v-list-item-title>
        </template>
        <v-list-item
            v-for="(item, index) in dropdown"
            :key="index"
            @click="open(item.id)"
        >
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
      </v-list-group>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
  export default {
    name: 'HomeDrawer',

    props: {
      items: {
        type: Array,
        default: () => ([]),
      },
      dropdown: {
        type: Array,
        default: () => ([]),
      }
    },
    methods: {
      open (id) {
        this.$emit('clikedMenuItem', id)
      }
    }
  }
</script>
